var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-display",on:{"scroll":_vm.hideFooterOnScroll}},[_c('h2',[_vm._v("\n    "+_vm._s(_vm.$route.params.lang === "fr" ? _vm.$route.meta.frenchName : _vm.$route.name)+"\n  ")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7df2dd06","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewDisplay.vue
// module id = 95
// module chunks = 0